<div class="oph-button-group" [ngStyle]="style" [class.disabled]="disabled" [class]="classes">
  @for (option of options; track option) {
    <button
      [ngStyle]="buttonStyle"
      [class.selected]="option.name === selectedOptionName"
      [class.disabled]="option.disabled"
      (click)="optionClick.emit(option.name)"
    >
      {{ option.display || option.name | titlecase }}
    </button>
  }
</div>
